// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle-btn {
  display: inline-block;
  outline: 0;
  width: 5em;
  height: 3em;
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #fbfbfb;
  border-radius: 2em;
  padding: 2px;
  transition: all 0.4s ease;
  border: 1px solid #e8eae9;
}

.underline-text {
  text-decoration: underline;
  text-decoration-color: blue;
}

.eligible-close {
  margin-top: -10%;
  margin-right: -2.5%;
}
@media screen and (max-width: 430px) {
  .eligible-close {
    margin-top: -17%;
  }
}
@media screen and (max-width: 353px) {
  .eligible-close {
    margin-top: -29%;
  }
}
@media screen and (max-width: 295px) {
  .eligible-close {
    margin-top: -45%;
  }
}
@media screen and (max-width: 245px) {
  .eligible-close {
    margin-top: -68%;
  }
}

.toggle-btn:focus::after,
.toggle-btn:active::after {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 0 rgba(0, 0, 0, 0.08), inset 0px 0px 0px 1.5px #9c9c9c;
}

.toggle-btn::after {
  left: 0;
  position: relative;
  display: block;
  content: "";
  width: 50%;
  height: 100%;
  border-radius: 2em;
  background: #fbfbfb;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), padding 0.3s ease, margin 0.3s ease;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
}

.toggle-btn.toggle-btn-on::after {
  left: 50%;
}

.toggle-btn.toggle-btn-on {
  background: #86d993;
}

.toggle-btn.toggle-btn-on:active {
  box-shadow: none;
}

.toggle-btn.toggle-btn-on:active::after {
  margin-left: -0.8em;
}

.toggle-btn:active::after {
  padding-right: 0.8em;
}

.toggle-input {
  display: none;
}

.bad-login {
  text-align: center;
}

.logo-center {
  display: flex;
  justify-content: center;
}

.info-icon {
  font-size: 1.5rem;
  transform: translateY(7px);
}

.info-icon:hover {
  cursor: pointer;
}

.message-box {
  display: none;
  margin: 0 !important;
  border: 1px solid #808080 !important;
  border-style: solid !important;
}

.message-box-visible {
  display: block;
  z-index: 1;
  border: 1px solid grey !important;
  box-shadow: 0px 0.46rem 2.18rem rgba(4, 9, 20, 0.03), 0px 0.93rem 1.4rem rgba(4, 9, 20, 0.03), 0px 0.25rem 0.53rem rgba(4, 9, 20, 0.05), 0px 0.12rem 0.18rem rgba(4, 9, 20, 0.03);
  font-size: 1.2rem;
  color: #333;
  font-weight: 500;
}

.align-label {
  align-self: baseline;
  padding-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/login/login.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;AACF;;AACA;EACE,0BAAA;EACA,2BAAA;AAEF;;AAEA;EACE,gBAAA;EACA,mBAAA;AACF;AAAG;EAHH;IAII,gBAAA;EAGF;AACF;AAFG;EANH;IAOI,gBAAA;EAKF;AACF;AAJG;EATH;IAUI,gBAAA;EAOF;AACF;AANG;EAZH;IAaI,gBAAA;EASF;AACF;;AANA;;EAEE,sGAAA;AASF;;AALA;EACE,OAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iGAAA;EAEA,wCAAA;AAOF;;AAJA;EACE,SAAA;AAOF;;AAJA;EACE,mBAAA;AAOF;;AAJA;EACE,gBAAA;AAOF;;AAJA;EACE,mBAAA;AAOF;;AAJA;EACE,oBAAA;AAOF;;AAJA;EACE,aAAA;AAOF;;AAJA;EACE,kBAAA;AAOF;;AAJA;EACE,aAAA;EACA,uBAAA;AAOF;;AAJA;EACE,iBAAA;EACA,0BAAA;AAOF;;AAJA;EACE,eAAA;AAOF;;AAJA;EACE,aAAA;EACA,oBAAA;EACA,oCAAA;EACA,8BAAA;AAOF;;AALA;EACE,cAAA;EACA,UAAA;EACA,iCAAA;EACA,iLAAA;EAIA,iBAAA;EACA,WAAA;EACA,gBAAA;AAKF;;AAAA;EACE,oBAAA;EACA,mBAAA;AAGF","sourcesContent":[".toggle-btn {\n  display: inline-block;\n  outline: 0;\n  width: 5em;\n  height: 3em;\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n  background: #fbfbfb;\n  border-radius: 2em;\n  padding: 2px;\n  transition: all 0.4s ease;\n  border: 1px solid #e8eae9;\n}\n.underline-text {\n  text-decoration: underline;\n  text-decoration-color:blue;\n}\n\n\n.eligible-close {\n  margin-top: -10%;\n  margin-right: -2.5%;\n   @media screen and (max-width: 430px) {\n    margin-top: -17%;\n   }\n   @media screen and (max-width: 353px) {\n    margin-top: -29%;\n   }\n   @media screen and (max-width: 295px) {\n    margin-top: -45%;\n   }\n   @media screen and (max-width: 245px) {\n    margin-top: -68%;\n   }\n}\n\n.toggle-btn:focus::after,\n.toggle-btn:active::after {\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 0 rgba(0, 0, 0, 0.08),\n    inset 0px 0px 0px 1.5px #9c9c9c;\n}\n\n.toggle-btn::after {\n  left: 0;\n  position: relative;\n  display: block;\n  content: '';\n  width: 50%;\n  height: 100%;\n  border-radius: 2em;\n  background: #fbfbfb;\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275),\n    padding 0.3s ease, margin 0.3s ease;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);\n}\n\n.toggle-btn.toggle-btn-on::after {\n  left: 50%;\n}\n\n.toggle-btn.toggle-btn-on {\n  background: #86d993;\n}\n\n.toggle-btn.toggle-btn-on:active {\n  box-shadow: none;\n}\n\n.toggle-btn.toggle-btn-on:active::after {\n  margin-left: -0.8em;\n}\n\n.toggle-btn:active::after {\n  padding-right: 0.8em;\n}\n\n.toggle-input {\n  display: none;\n}\n\n.bad-login {\n  text-align: center;\n}\n\n.logo-center {\n  display: flex;\n  justify-content: center;\n}\n\n.info-icon {\n  font-size: 1.5rem;\n  transform: translateY(7px);\n}\n\n.info-icon:hover {\n  cursor: pointer;\n}\n\n.message-box {\n  display: none;\n  margin: 0 !important;\n  border: 1px solid #808080 !important;\n  border-style: solid !important;\n}\n.message-box-visible {\n  display: block;\n  z-index: 1;\n  border: 1px solid grey !important;\n  box-shadow: 0px 0.46rem 2.18rem rgba(4, 9, 20, 0.03),\n    0px 0.93rem 1.4rem rgba(4, 9, 20, 0.03),\n    0px 0.25rem 0.53rem rgba(4, 9, 20, 0.05),\n    0px 0.12rem 0.18rem rgba(4, 9, 20, 0.03);\n  font-size: 1.2rem;\n  color: #333;\n  font-weight: 500;\n}\n\n\n\n.align-label {\n  align-self: baseline;\n  padding-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
